import React, { createContext, useContext } from 'react';
const ApplicationConfig = /*#__PURE__*/createContext(null);
export const ApplicationConfigProvider = _ref => {
  let {
    children,
    applicationConfig
  } = _ref;
  return /*#__PURE__*/React.createElement(ApplicationConfig.Provider, {
    value: applicationConfig
  }, children);
};
export const useApplicationConfig = () => {
  return useContext(ApplicationConfig);
};
export const useEnvironment = () => {
  const applicationConfig = useApplicationConfig();
  const environment = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.environment;
  if (!environment) {
    throw new Error('useEnvironment must be used within a ApplicationConfigProvider');
  }
  return environment;
};
export const useAlgoliaConfig = () => {
  const applicationConfig = useApplicationConfig();
  const algoliaConfig = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.algoliaConfig;
  if (!algoliaConfig) {
    throw new Error('useAlgoliaConfig must be used within a ApplicationConfigProvider');
  }
  return algoliaConfig;
};
export const useHostUrl = () => {
  const applicationConfig = useApplicationConfig();
  const hostUrl = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.hostUrl;
  if (!hostUrl) {
    throw new Error('useHostUrl must be used within a ApplicationConfigProvider');
  }
  return hostUrl;
};
export const useSource = () => {
  const applicationConfig = useApplicationConfig();
  const source = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.source;
  if (!source) {
    throw new Error('useSource must be used within a ApplicationConfigProvider');
  }
  return source;
};